export default "__VITE_ASSET__CrI615j6__"